module.exports = __webpack_public_path__ + "img/player-zh.35b17222.webp";